import { CreateOfferRequestPaymentIntentState } from './createOfferRequestPaymentIntent.types'

const initialState: CreateOfferRequestPaymentIntentState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
